import React, { useState, useEffect } from 'react';
import styles from './index.module.css';
import { Link } from 'react-router-dom';

const Index = () => {
  const [banner, setBanner] = useState(0);

  const nextBanner = () => {
    setBanner(banner === 5 ? 0 : banner + 1);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextBanner();
    }, 3000);
    return () => clearInterval(interval);
  }, [banner]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.banner}>
        <h1 className={styles.banner_title}>
          Консультации с личным психологом 24/7
        </h1>

        <div className={styles.banner_slider}>
          <div
            className={styles.banner_wrapper}
            style={{ transform: `translateY(-${banner * 147}px)` }}
          >
            <div className={styles.banner_slide}>повысить качество жизни</div>
            <div className={styles.banner_slide}>справиться со стрессом</div>
            <div className={styles.banner_slide}>наладить отношения</div>
            <div className={styles.banner_slide}>найти своё призвание</div>
            <div className={styles.banner_slide}>принять себя</div>
            <div className={styles.banner_slide}>обрести спокойствие</div>
          </div>
        </div>

        <Link to={'/auth'} className={styles.button} aria-label="Start a conversation with a psychologist">
          Начать диалог
        </Link>
      </div>

      <div className={styles.phone}></div>
    </div>
  );
};

export default Index;
